/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useCallback, useState, Fragment } from 'react';
import Typography from '@egalite/ui/Typography';
import { SecondaryButton } from '@egalite/ui/Buttons/GeneralButtons';
import Steps from '@egalite/ui/Steps';
import Icon from '@egalite/ui/Icon';
import Link from 'next/link';
import { useRouter, useSearchParams } from 'next/navigation';

const Background = () => (
	<div className="block absolute top-0 -right-6 w-[calc(100%+30px)] h-28 rounded-b-4xl bg-base-grey-2 z-[-1] lg:-right-80 lg:w-[50vw] lg:rounded-none lg:h-[calc(100%+100px)]"></div>
);
const ProgressBar = ({ progress, barColor = 'brand-main', compact }) => (
	<div className={`bg-base-grey-3 rounded h-[1.1rem] w-full relative ${compact ? 'mt-2 mb-2' : 'mt-8 mb-4'}`}>
		<div
			className={`progress w-[var(--progress)] bg-${barColor ? barColor : 'brand-main'} rounded h-[1.1rem] absolute top-0 left-0`}
			style={{ '--progress': `${progress}%` }}
		/>
	</div>
);
export default function FormPage({
	actualStep = 1,
	formTitle = 'form',
	formActualStep = 1,
	formTotalSteps = 1,
	progress = 0,
	showStepsMenu = true,
	showProgressBar = true,
	jobId = null,
	children,
	modal = false,
}) {
	const [showSteps, setShowSteps] = useState(false);
	const router = useRouter();
	const params = useSearchParams();
	const jobIdParam = params.get('jobId');

	const toggleSteps = useCallback(() => {
		setShowSteps(!showSteps);
	}, [showSteps]);

	if(modal){
		return <div className='p-12 pt-0'>{children}</div>
	}

	return (
		<Fragment>
			<div className="container">
				<div className="mb-24">
					<div className="flex flex-col lg:flex-row gap-8 lg:gap-[310px]">
						<div className="flex relative flex-row lg:flex-col justify-between">
							<Background />
							<div className="flex lg:hidden items-center pt-8 justify-center relative w-full">

								{/* Só existe no mobile e o Icon é aria-hidden — sem aria-label o botão fica sem nome. */}
								<button
									variant="small"
									aria-label="Voltar"
									className="h-[44px] w-[44px] bg-transparent border-none p-4 -ml-4 text-md text-brand-main flex items-center justify-center gap-4 absolute left-4"
									onClick={() => router.back()}
								>
									<Icon className="fi fi-br-arrow-left text-base" />
								</button>

								<Typography variant="headline-6" asEl="h1" className="text-base-grey-5">
									Cadastro do&nbsp;Candidato
								</Typography>
								{showStepsMenu ? (
									<SecondaryButton
										variant="small"
										onClick={toggleSteps}
										className="bg-transparent border border-base-grey-4 text-base-grey-4 min-w-auto p-4 rounded-2xl text-[1.4rem]"
									>
										{!showSteps ? 'Etapas' : 'Fechar'}
									</SecondaryButton>
								) : (
									false
								)}
							</div>
							<div className='hidden lg:block'>
								<Steps
									actualStep={actualStep}
									title={<Fragment>Cadastro do&nbsp;Candidato</Fragment>}
									subtitle={'Exclusivo para pessoas com deficiência'}
									icons={[
										<Icon key={0} className="fi fi-br-key" />,
										<Icon key={1} className="fi fi-br-portrait" />,
										<Icon key={2} className="fi fi-br-document" />,
										<Icon key={3} icon="disability" />,
									]}
									labels={['Dados cadastrais', 'Dados pessoais', 'Dados profissionais', 'Dados da deficiência']}
									links={[
										'/candidato/form/editRegister',
										'/candidato/form/personalData1',
										'/candidato/form/professionalData1',
										'/candidato/form/disabilityDataIndex',
									]}
									actionButtonText={'Sair do cadastro'}
									actionButtonUrl={'/candidato'}
									open={showSteps}
								/>
							</div>
						</div>
						{!showSteps ? (
							<div className='w-full'>
								<div className="max-w-[645px] lg:max-w-none mx-auto">
									{showProgressBar ? (
										<div className='md:mb-24 mb-16'>
											<div className="flex items-end justify-between mt-10 lg:mt-36 gap-8">
												<Typography variant="h3" component="h2" className="mb-0 text-base-grey-5 text-[1.8rem] md:text-[2.8rem]">
													{formTitle}
												</Typography>
												<Typography variant="body2" color="brand.main" className="leading-tight mb-0">
													Passo&nbsp;{formActualStep}/{formTotalSteps}
												</Typography>
											</div>
											<ProgressBar progress={progress} />
										</div>
									) : null}

									{children}
								</div>
							</div>
						) : null}
					</div>
				</div>
			</div>
		</Fragment>
	);
}
